import { Box, Card, GridLegacy as Grid, Stack, Typography } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";

import { formatInteger } from "@/utils/number";

import { AdminFilterPanel } from "./AdminFilterPanel";

interface AdminFilterSummaryProps {
  filter: React.ReactNode;
  count: number;
  countLabel: string;
  icon: React.ReactNode;
  filterMdSize?: number;
  summaryMdSize?: number;
}

/**
 * Pairs an admin context/filter control with a concise summary of the items it displays.
 * The page owns filter behavior while this component keeps the shared layout consistent.
 */
export const AdminFilterSummary: React.FC<AdminFilterSummaryProps> = ({
  filter,
  count,
  countLabel,
  icon,
  filterMdSize = 8,
  summaryMdSize = 4,
}) => {
  const { i18n } = useTranslation();
  const locale = i18n.resolvedLanguage || i18n.language;

  return (
    <Grid container spacing={3} sx={{ mb: 4 }}>
      <Grid item xs={12} md={filterMdSize}>
        <AdminFilterPanel sx={{ mb: 0, height: "100%" }}>{filter}</AdminFilterPanel>
      </Grid>
      <Grid item xs={12} md={summaryMdSize}>
        <Card sx={{ p: 2, height: "100%", display: "flex", alignItems: "center" }}>
          <Stack direction="row" spacing={2} alignItems="center">
            {icon}
            <Box>
              <Typography variant="body2" color="text.secondary">
                {countLabel}
              </Typography>
              <Typography variant="h4">{formatInteger(count, locale)}</Typography>
            </Box>
          </Stack>
        </Card>
      </Grid>
    </Grid>
  );
};
